var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.ArticleKeyWord},[_c('h2',{staticClass:"ArticleKeyWord__title"},[_vm._v("關鍵字")]),_c('div',_vm._l((_vm.list),function(item,index){return _c('h4',{key:index,staticClass:"badge-gray"},[_c('router-link',{staticClass:"badge-gray__link",attrs:{"to":{
          name: 'search',
          params: {
            tagTitle: item.title,
          },
          query: {
            tag: item.alias,
          },
        }}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }